export const common = {
  // Navigation
  home: 'Inicio',
  services: 'Servicios',
  about: 'Acerca de',
  gallery: 'Galería',
  contact: 'Contacto',
  reserve: 'Reservar',
  
  // Buttons
  bookNow: 'Reserve Ahora',
  learnMore: 'Más información',
  whatsapp: 'WhatsApp',
  close: 'Cerrar',
  
  // Hero Section
  heroTitle: 'Viaje con',
  heroTitleHighlight: 'Elegancia',
  heroDescription: 'Descubra Marruecos y Canadá de otra manera con nuestro servicio de transporte premium. Comodidad, seguridad y hospitalidad auténtica.',
  
  // Services
  servicesTitle: 'Nuestros Servicios Premium',
  servicesDescription: 'Una gama completa de servicios de transporte turístico para satisfacer todas sus necesidades de viaje, desde el traslado simple hasta los circuitos más exclusivos.',
  
  // About
  aboutTitle: 'Nuestra Historia',
  aboutDescription1: 'Desde hace más de 10 años, ofrecemos una experiencia excepcional de transporte turístico en Marruecos y Canadá. Nuestra pasión por la hospitalidad marroquí y nuestra experiencia del terreno nos permiten crear viajes inolvidables.',
  aboutDescription2: 'Ya sea un viajero de negocios, una familia de vacaciones o un grupo de amigos en busca de aventura, ponemos nuestro saber hacer a su servicio para que cada kilómetro sea un placer.',
  
  // Values
  security: 'Seguridad',
  securityDesc: 'Vehículos mantenidos y conductores certificados para su tranquilidad.',
  punctuality: 'Puntualidad',
  punctualityDesc: 'Respeto de horarios y compromisos para un servicio confiable.',
  hospitality: 'Hospitalidad',
  hospitalityDesc: 'Acogida cálida y servicio personalizado en la tradición marroquí.',
  excellence: 'Excelencia',
  excellenceDesc: 'Búsqueda constante de la perfección en cada detalle de nuestros servicios.',
  
  // Testimonials
  testimonialsTitle: 'Testimonios de Clientes',
  testimonialsDescription: 'Descubra lo que nuestros clientes dicen sobre su experiencia con nuestro servicio de transporte premium.',
  satisfiedClients: 'Clientes Satisfechos',
  destinations: 'Destinos',
  customerService: 'Servicio al Cliente',
  
  // Reservation
  reservationTitle: 'Reserve Su Transporte',
  reservationDescription: 'Complete el formulario a continuación para obtener un presupuesto personalizado o reserve directamente su servicio de transporte premium.',
  fullName: 'Nombre completo',
  email: 'Correo electrónico',
  phone: 'Teléfono',
  desiredService: 'Servicio deseado',
  selectService: 'Seleccione un servicio',
  departureDate: 'Fecha de salida',
  departureTime: 'Hora de salida',
  passengers: 'Pasajeros',
  passenger: 'pasajero',
  departureLocation: 'Lugar de salida',
  destination: 'Destino',
  message: 'Mensaje o solicitudes especiales',
  messageDescription: 'Describa sus necesidades específicas, preferencias o preguntas...',
  sendRequest: 'Enviar solicitud',
  sending: 'Enviando...',
  directContact: 'Contacto Directo',
  availability: 'Disponibilidad',
  quickResponse: 'Respuesta Rápida',
  quickResponseDescription: 'Nos comprometemos a responderle lo antes posible:',
  whatsappResponse: 'WhatsApp: Respuesta inmediata',
  emailResponse: 'Correo: En 2 horas',
  freeQuote: 'Presupuesto gratuito y sin compromiso',
  
  // Contact
  contactTitle: 'Contáctenos',
  contactDescription: 'Nuestro equipo está a su disposición para responder todas sus preguntas y acompañarle en la organización de sus desplazamientos.',
  sendMessage: 'Envíenos un mensaje',
  subject: 'Asunto',
  selectSubject: 'Seleccione un asunto',
  quoteRequest: 'Solicitud de presupuesto',
  serviceInfo: 'Información sobre nuestros servicios',
  complaint: 'Reclamación',
  partnership: 'Propuesta de asociación',
  other: 'Otro',
  messageRequired: 'Mensaje',
  messageContactDescription: 'Describa su solicitud en detalle...',
  sendMessageBtn: 'Enviar mensaje',
  ourCoordinates: 'Nuestros Datos',
  address: 'Dirección',
  telephone: 'Teléfono',
  hours: 'Horarios',
  officeHours: 'Oficina: 8h - 20h',
  followUs: 'Síguenos',
  ourLocation: 'Nuestra Ubicación',
  
  // Form Messages
  successMessage: '¡Su solicitud ha sido enviada con éxito! Nos pondremos en contacto pronto.',
  successContactMessage: '¡Su mensaje ha sido enviado con éxito! Le responderemos pronto.',
  errorMessage: 'Se produjo un error. Por favor, inténtelo de nuevo o contáctenos directamente.',
  charactersLimit: 'caracteres',
  
  // Footer
  footerDescription: 'Su socio de confianza para transporte turístico de lujo en Marruecos y Canadá. Descubra nuestros destinos con elegancia y comodidad.',
  ourServices: 'Nuestros Servicios',
  copyright: '© 2024 HAFY TOURS. Todos los derechos reservados.',
  poweredBy: 'Powered by Readdy',
  
  // Common
  yearsExperience: 'Años de experiencia',
  includedInService: 'Incluido en el servicio',
  reserveThisService: 'Reservar este servicio',
  chatOnWhatsApp: 'Chatear en WhatsApp',
  notAvailableYet: 'Aún no disponible por el momento',
  required: '*',
  placeholderName: 'Su nombre completo',
  placeholderEmail: 'su@email.com',
  placeholderPhone: '+212 6XX XXX XXX',
  placeholderDeparture: 'Aeropuerto, hotel, dirección...',
  placeholderDestination: 'Ciudad, sitio turístico...'
};